import React from 'react'

export default function FacebookLogo() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"> 
      <path d="M15.8337 4.98687H17.7509V1.64787C17.4201 1.60238 16.2826 1.5 14.9579 1.5C12.1938 1.5 10.3003 3.23863 10.3003 6.43412V9.375H7.25V13.1077H10.3003V22.5H14.04V13.1086H16.9669L17.4315 9.37588H14.0391V6.80425C14.04 5.72537 14.3305 4.98687 15.8337 4.98687Z" fill="#4867AA"/>
    </svg>
  )
}